import DialogContent, { DialogContentProps } from '@material-ui/core/DialogContent';
import classNames from 'classnames';
import React from 'react';
import styles from './StyledDialog.module.scss';

export class StyledDialogContent extends React.Component<
    DialogContentProps & {
        noPadding?: boolean;
        contentHeight?: number;
        backgroundClass?: string;
    }
> {
    public static muiName = 'DialogContent';

    public render() {
        const { contentHeight, children, noPadding, backgroundClass, ...otherProps } = this.props;

        const dialogClasses = classNames(styles.dialogContent, !!backgroundClass && backgroundClass, {
            [styles.noPadding]: !!noPadding
        });

        return (
            <DialogContent {...otherProps} className={dialogClasses}>
                {contentHeight ? (
                    <div style={{ minHeight: contentHeight, height: contentHeight, width: '100%' }}>{children}</div>
                ) : (
                    children
                )}
            </DialogContent>
        );
    }
}
